<template>
 <div>
    <!--<b-modal size="xl" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalcategory" @close="this.emitEventCancel" @ok="this.emitEventOK" @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> -->
       <b-modal  :id="ModalId" size="lg" :no-close-on-backdrop="true" hide-header :no-close-on-esc="true" @hide="emitEventCancel" :ok-title="'Select'" centered :title="TitleWindow" :visible="true"  @ok="this.emitEventOK" :cancel-title="$t('Shared.BtnCancel')">
    
  
        <MdNote
          v-bind:NOTE="this.Header.description"	
          v-bind:Time="this.Header.Time"
          v-bind:EventScheduler="false"
       
          v-bind:IsUserSetup="true"
          v-bind:Header="this.Header"
          v-bind:TransDate="Header.transDate"
          v-bind:IsChartReview="false"
          v-bind:IsClinicalNote="true"
          v-bind:IsEmployeeInbox="true"
          v-bind:ProgramCode="Header.programCode"
          v-bind:CategoryCode="CategoryCode">
        </MdNote>
    </b-modal>   
   </div>
   

</template>

<script>
//import ClinicalService from '@/services/clinical.service'
//import LoadingNote from '@/components/template/loading/Loading'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
//import { EventBus } from '@/event-bus.js';
//import ISetup from '@/services/isetup.service'
//import PatientService from '@/services/patient.service'
//import moment from 'moment'


export default {
    props: {
        ModalId: String,
        TitleWindow: String, 
        Header:Object,
        CategoryCode:String,
        NoteName:String,   
        NoteId:[Number,String]
    },
  components: {    
   
  },
  mixins: [ShowMessage, DBFunctions],
  name: 'IniModalOpenNote',
  data(){
    return{   
      FormId:this.NoteId.toString(),
      parameter:{
        PageSize:10,
        PageNumber:1
      },
      
//Header:{},
      
      Load: false,

    }
  },
  methods:{

    emitEventOK(){
       this.$emit('onSelectSetupNote',this.NoteId); 
    },

    emitEventCancel(){
      this.$emit('onCloseSetupNote'); 
    },

   

    
   
  },
  created(){
  // await this.getNoteDefaultHeader();
  },
  mounted(){
   // this.getPatients();
  }   
};
</script>

<style>


#OpenIdNoteModal___BV_modal_body_ {
    padding: 5px;
   
  }

  #OpenIdNoteModal{
    margin-top:42px;
  }
 
</style>


